
<template>
  <div>
    <v-row justify='space-around'>
      <v-col cols='11' sm='6' md='4'>
        <v-card style="border-radius:12px">
          <v-card-text>
            <div :class="['text-center headline', same_ammount ? 'success--text' : 'black--text']">{{order_sell_price}}</div>
            <div class="text-center title">Total do pedido</div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols='11' sm='6' md='4'>
        <v-card style="border-radius:12px">
          <v-card-text>
            <div :class="['text-center headline', same_ammount ? 'success--text' : 'error--text']">{{partials_sum}}</div>
            <div class="text-center title">Total em faturas</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <template>
      <v-form ref="form">
        <div v-for="(payment, idx) in order.payments.list" :key="payment.ref">
          <payment-selection :order="order" :wholesale="wholesale" :idx="idx+1" :one_payment="payment" :payment_times="all_pay_times" :payment_options="all_pay_options" @delete="handleDelete"></payment-selection>
        </div>
      </v-form>
    </template>
    <v-alert v-if="order.payments.cash_idxes && order.payments.cash_idxes.length > 1" type="info">
      Atenção. Existe mais de um pagamento em dinheiro. Pagamentos: {{order.payments.cash_idxes.map(a=>a+1).join(', ')}}
    </v-alert>

    <v-row justify='center' class="py-5">
      <v-btn :disabled="same_ammount" color="primary" small @click="addPayment()"> <v-icon left>mdi-plus</v-icon> parcela </v-btn>
    </v-row>
  </div>
</template>

<script>
import { mapState,} from 'vuex'
import Api from '@/api/index';

export default {
  name: 'EditOrderPayments',
  components: {
    PaymentSelection: () => import('@/components/create_order/shared/payments/PaymentSelection.vue'),
  },
  props: {
    order: {
      type: Object,
    },
    wholesale:{
      type: Boolean,
      default: false,
    },
    retail: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      key: null,
      all_pay_options: [],
      load_pay_options: false,

      all_pay_times: [],
      load_pay_times: false,
    }
  },
  methods: {
    validate(){
      return this.$refs.form.validate() && this.same_ammount
    },
    getPaymentTimes() {
      this.load_pay_times = true
      Api.PaymentOption.index('times').then(r=>r.data).then(pay=>{
        this.all_pay_times = [...pay.data.map(el=>{return {...el, id: parseInt(el.id)} })]
      }).catch(err=>{

      }).finally(()=>{
        this.load_pay_times = false
      })
    },
    getPaymentOptions() {
      this.load_pay_options = true
      Api.PaymentOption.index('options').then(r=>r.data).then(pay=>{
        this.all_pay_options = [...pay.data.map(el=>{return {...el, id: parseInt(el.id)} })]
      }).catch(err=>{

      }).finally(()=>{
        this.load_pay_options = false
      })
    },
    addPayment(){
      this.order.payments.list.push({  
        payment_option_id: null,
        payment_time_id: null,
        ammount: '0.00',
        ref: Math.round(Math.random()*10000)
      })
    },
    setDefaultPaymentsPercentage(){
      // CODIGO PARA CALCULAR A PORCENTAGEM DO PAYMENT DO CLIENTE E SETAR AUTOMATICO
      if(this.retail && this.order.client_id){
        let sell = this.order.items_attributes.reduce((acc, el) => Number(el.total_sell_price) + acc, 0 )
        
        this.order.payments.list.map(el => {
          if(el.percentage > 0) return el.ammount = (sell * el.percentage / 100).toFixed(2);
        })
        let total_payment = this.order.payments.list.reduce((acc, el) => Number(el.ammount) + acc, 0 )

        if( total_payment != sell){
          this.order.payments.list[this.order.payments.list.length -1].ammount = (  
            Number(this.order.payments.list[this.order.payments.list.length -1].ammount) - (Number(total_payment) - Number(sell))
          ).toFixed(2);
        }
  
      }
    },
    deleteNewOrderPayment(idx){
      if (idx != null && idx != undefined) {
        this.order.payments.list.splice(idx, 1)
      }
    },
    handleDelete(index){
      this.deleteNewOrderPayment(index)
    },
  },
  mounted () {
    this.getPaymentTimes();
    this.getPaymentOptions();
    this.setDefaultPaymentsPercentage();
  },
  computed: {
    order_sell_price() {
      let sell_price = null
      
      if(this.order.total_order_sell){
        sell_price = this.order.total_order_sell 
      }else{
        sell_price = this.order.items_attributes?.reduce((acc, one) => Number(one.total_sell_price) + acc, 0 )
      }
      return Number(sell_price).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
    },
    partials_sum() {
      let partial = this.order.payments.list.reduce((acc, one) => parseFloat(String(one.ammount).replaceAll(',', ''))+acc, 0)
      if(isNaN(partial)){
        partial = 0
        return partial.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
      }else{
        return partial.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
      }
    },
    same_ammount(){
      return this.order_sell_price == this.partials_sum
    },
    all_loaded(){
      return this.load_pay_options && this.load_pay_times
    },
  },
  watch: {
    'order.payments.list': {
      deep:true,
      handler(nv){
        let opt_ids = nv.map(n=>n.payment_option_id)
        
        if(this.all_pay_options.length > 0) {
          let dep_id = this.all_pay_options.find(opt=> opt.attributes.description.trim().toUpperCase() == 'DEPÓSITO').id
          this.order.payments.has_deposit = opt_ids.includes(dep_id)
          this.order.payments.dep_idxes = opt_ids.map((o,i)=> o == dep_id? i+1 : -1).filter(o=> o>0).map(o=> o-1)
          
          let cash_id = this.all_pay_options.find(opt=> opt.attributes.description.trim().toUpperCase() == 'DINHEIRO').id
          this.order.payments.has_cash = opt_ids.includes(cash_id)
          this.order.payments.cash_id = cash_id
          this.order.payments.cash_idx = opt_ids.findIndex(o=>o == cash_id)
          this.order.payments.cash_idxes = opt_ids.map((o,i)=> o == cash_id? i+1 : -1).filter(o=> o>0).map(o=> o-1)
        }
      }
    },
  },
}
</script>
